import React from 'react'
import './Navbar.scss';

function Navbar() {
    return (
        <div className="navbar">
            <div className="logo">Restaurant POS</div>
        </div>
    )
}

export default Navbar
